import type { SVGProps } from "react";

export default function PinOff(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth={1.3}
      {...props}
    >
      <path
        d="M12 17V22M14.9999 9.34V7C14.9999 6.73478 15.1052 6.48043 15.2928 6.29289C15.4803 6.10536 15.7347 6 15.9999 6C16.5303 6 17.039 5.78929 17.4141 5.41421C17.7892 5.03914 17.9999 4.53043 17.9999 4C17.9999 3.46957 17.7892 2.96086 17.4141 2.58579C17.039 2.21071 16.5303 2 15.9999 2H7.88989M2 2L22 22M9 9V10.76C8.9998 11.1321 8.89581 11.4967 8.69972 11.813C8.50363 12.1292 8.22321 12.3844 7.89 12.55L6.11 13.45C5.77679 13.6156 5.49637 13.8708 5.30028 14.187C5.10419 14.5033 5.0002 14.8679 5 15.24V16C5 16.2652 5.10536 16.5196 5.29289 16.7071C5.48043 16.8946 5.73478 17 6 17H17"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
